// src/components/StrzelnicaKarta.jsx
// Jedna karta obiektu - używana przez katalog /strzelnice i wszystkie podstrony
// (województwo, miasto, powiat, ranking), żeby dane były prezentowane spójnie.
import React from 'react';
import styles from '../css/modules/Strzelnice.module.css';
import { KRYTERIA } from '../data/strzelnice';
import OpiniePanel from './Opinie';
import { trackEvent } from '../lib/analytics';

const telHref = phone => `tel:${phone.replace(/\s/g, '')}`;

/* Dla części obiektów znamy tylko miejscowość - wtedy etykieta „Adres”
   obiecywałaby więcej, niż mamy w danych. */
const addressLabel = value => (/\d/.test(value) ? 'Adres' : 'Miejscowość');

const prettyUrl = url => url.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');

const StrzelnicaKarta = ({ item, position, showPlace = false, showCriteria = false }) => (
  <li className={styles.card}>
    <h4 className={styles.name}>
      {position ? <span className={styles.position}>{position}.</span> : null}
      {item.n}
    </h4>
    {showPlace && (
      <p className={styles.place}>
        {item.c}
        {item.p && item.p !== item.c ? `, ${item.p}` : ''} · woj. {item.rw}
      </p>
    )}
    {item.d && <p className={styles.desc}>{item.d}</p>}
    <dl className={styles.meta}>
      {item.a && (
        <>
          <dt>{addressLabel(item.a)}</dt>
          <dd>{item.a}</dd>
        </>
      )}
      {item.t && (
        <>
          <dt>Telefon</dt>
          <dd>
            <a href={telHref(item.t)}>{item.t}</a>
            {item.t2 && (
              <>
                {', '}
                <a href={telHref(item.t2)}>{item.t2}</a>
              </>
            )}
          </dd>
        </>
      )}
      {item.e && (
        <>
          <dt>E-mail</dt>
          <dd>
            <a href={`mailto:${item.e}`}>{item.e}</a>
          </dd>
        </>
      )}
      {(item.w || item.f) && (
        <>
          <dt>Strona</dt>
          <dd>
            <a
              href={item.w || item.f}
              target="_blank"
              rel="noopener nofollow ugc"
              onClick={() => trackEvent('outbound_range', { label: item.n })}
            >
              {prettyUrl(item.w || item.f)}
            </a>
          </dd>
        </>
      )}
      {item.h && (
        <>
          <dt>Godziny</dt>
          <dd>{item.h}</dd>
        </>
      )}
    </dl>
    <OpiniePanel rangeId={item.id} rangeName={item.n} />
    {showCriteria && item.k.length > 0 && (
      <ul className={styles.criteria}>
        {item.k.map(code => (
          <li key={code}>{KRYTERIA[code]}</li>
        ))}
      </ul>
    )}
  </li>
);

export default StrzelnicaKarta;
